import React from 'react';
import PropTypes from 'prop-types';

import {
  availableAccountRoutes,
  availablePaymentRoutes,
  CLIENT_PROFILE_COMPONENT_TYPES,
  historyAvailableRoutes,
  responsibleGamingAvailableRoutes,
} from '@atlas/routing';
import { HeaderTitle } from '@atlas/ui';

import bonusesTabRoutes from 'components/ClientProfile/Bonuses/bonusesTabRoutes';
import ClientProfileSubNavigation from 'components/ClientProfile/ClientProfileSubNavigation';

const availableTabsByComponentType = {
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE]: availableAccountRoutes,
  [CLIENT_PROFILE_COMPONENT_TYPES.PAYMENT]: availablePaymentRoutes,
  [CLIENT_PROFILE_COMPONENT_TYPES.HISTORY]: historyAvailableRoutes,
  [CLIENT_PROFILE_COMPONENT_TYPES.RESPONSIBLE_GAMING]: responsibleGamingAvailableRoutes,
  [CLIENT_PROFILE_COMPONENT_TYPES.BONUSES]: bonusesTabRoutes,
};

const ExpandedNavigationItem = ({ link, name, tabs, type }) => {
  const availableTabs = availableTabsByComponentType[type];

  return (
    <div className="user-profile-group-item">
      <div className="title-wrapper">
        <HeaderTitle className="sub-text block-small border" title={name} />
      </div>
      <ClientProfileSubNavigation availableTabs={availableTabs} parentRoute={link} tabs={tabs} />
    </div>
  );
};

ExpandedNavigationItem.propTypes = {
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tabs: PropTypes.array.isRequired,
  type: PropTypes.string.isRequired,
};

export default ExpandedNavigationItem;
